export default __webpack_public_path__ + "static/media/Nash.5ab2266e.jpeg";